import React from 'react'
import { Button } from "antd"
import { ExportErrorDetail } from "../../../../services/api/3dApi"


const ExportDetailError = ({ changeContent, match }) => {

    const _handleClick = () => {
        window.open(ExportErrorDetail(match.params.id))
    }
    return (
        <Button icon='cloud-download' className="mr-3 mt-2"
            onClick={_handleClick}
            disabled={changeContent}>
            Xuất chi tiết lỗi
        </Button>
    )
}

export default ExportDetailError